import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { InnovationPrioritiesProvider as Provider } from '../../components/context/innovation-priorities-context';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const QUERY = graphql`
query NodeAllInnovationPrioritiesQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "InnovationPriorities" } }) {
    nodes {
      data
    }
  }
}
`;

export const InnovationPrioritiesProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(QUERY), 'items')}>{children}</Provider>;
};
